import React from 'react';
import { Settings2, Sliders } from 'lucide-react';
import { AgentFilters } from '../utils/agentMatrix';
interface AdminFilterPanelProps {
  filters: AgentFilters;
  onChange: (filters: AgentFilters) => void;
}
export function AdminFilterPanel({
  filters,
  onChange
}: AdminFilterPanelProps) {
  const handleChange = (key: keyof AgentFilters, value: any) => {
    onChange({
      ...filters,
      [key]: value
    });
  };
  return <div className="bg-white/80 backdrop-blur-md rounded-3xl shadow-sm border border-white p-6 w-full" data-id="element-34">
      <div className="flex items-center gap-2 mb-6 pb-4 border-b border-gray-100/50" data-id="element-35">
        <Settings2 className="w-5 h-5 text-gray-500" data-id="element-36" />
        <h2 className="text-lg font-bold text-gray-900" data-id="element-37">Training Filters</h2>
      </div>

      <div className="space-y-5" data-id="element-38">
        {/* Lead Type */}
        <div data-id="element-39">
          <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-40">
            Lead Type
          </label>
          <div className="relative" data-id="element-41">
            <select value={filters.leadType} onChange={e => handleChange('leadType', e.target.value)} className="w-full appearance-none bg-gray-50 border-0 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-black block p-4 pr-8 font-medium" data-id="element-42">
              <option value="Outbound" data-id="element-43">Outbound</option>
              <option value="Inbound" data-id="element-44">Inbound</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-45">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-46">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-47"></path>
              </svg>
            </div>
          </div>
        </div>

        {/* Lead Source */}
        <div data-id="element-48">
          <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-49">
            Lead Source
          </label>
          <div className="relative" data-id="element-50">
            <select value={filters.leadSource} onChange={e => handleChange('leadSource', e.target.value)} className="w-full appearance-none bg-gray-50 border-0 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-black block p-4 pr-8 font-medium" data-id="element-51">
              <option value="Facebook" data-id="element-52">Facebook</option>
              <option value="Instagram" data-id="element-53">Instagram</option>
              <option value="Phone" data-id="element-54">Phone</option>
              <option value="SMS" data-id="element-55">SMS</option>
              <option value="Email" data-id="element-56">Email</option>
              <option value="Referral" data-id="element-57">Referral</option>
              <option value="Google" data-id="element-58">Google</option>
              <option value="Mailer" data-id="element-59">Mailer</option>
              <option value="Other" data-id="element-60">Other</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-61">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-62">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-63"></path>
              </svg>
            </div>
          </div>
        </div>

        {/* Difficulty Slider */}
        <div data-id="element-64">
          <div className="flex justify-between items-center mb-2" data-id="element-65">
            <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-66">
              Difficulty
            </label>
            <span className="text-sm font-bold text-black bg-gray-200 px-2 py-1 rounded-md" data-id="element-67">
              {filters.difficulty}/10
            </span>
          </div>
          <input type="range" min="1" max="10" value={filters.difficulty} onChange={e => handleChange('difficulty', parseInt(e.target.value))} className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-black" data-id="element-68" />
        </div>

        {/* Product Interest */}
        <div data-id="element-69">
          <label className="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-2" data-id="element-70">
            Product Interest
          </label>
          <div className="relative" data-id="element-71">
            <select value={filters.productInterest} onChange={e => handleChange('productInterest', e.target.value)} className="w-full appearance-none bg-gray-50 border-0 text-gray-900 text-sm rounded-xl focus:ring-2 focus:ring-black block p-4 pr-8 font-medium" data-id="element-72">
              <option value="" data-id="element-73">Select interest...</option>
              <option value="CRM & Lead Management" data-id="element-74">
                CRM & Lead Management
              </option>
              <option value="Marketing Automation" data-id="element-75">Marketing Automation</option>
              <option value="Funnels & Websites" data-id="element-76">Funnels & Websites</option>
              <option value="Advertising & Paid Media" data-id="element-77">
                Advertising & Paid Media
              </option>
              <option value="Social Media Management" data-id="element-78">
                Social Media Management
              </option>
              <option value="SEO & Local Listings" data-id="element-79">SEO & Local Listings</option>
              <option value="Reputation & Reviews" data-id="element-80">Reputation & Reviews</option>
              <option value="AI Chat & Voice Assistants" data-id="element-81">
                AI Chat & Voice Assistants
              </option>
              <option value="Analytics & Reporting" data-id="element-82">
                Analytics & Reporting
              </option>
              <option value="Other" data-id="element-83">Other</option>
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-500" data-id="element-84">
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-85">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-86"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>;
}